import { createSelector } from '@ngrx/store';
import * as fromReducers from '../reducers';

export const getFlightClassesFeatureState = createSelector(
  fromReducers.getFlightSearchDataState,
  (state: fromReducers.FlightSearchDataState) => (state ? state.flightClasses : [])
);

export const getFlightClassById = (classId: string) =>
  createSelector(getFlightClassesFeatureState, (classes) => classes.filter((classObj) => classObj.id === classId)[0]);
